/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container[_ngcontent-%COMP%]{padding-bottom:15px}.overlay[_ngcontent-%COMP%]{display:block;z-index:1;position:fixed;pointer-events:none;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.5);opacity:0;-webkit-transition:opacity .15s ease-in-out;transition:opacity .15s ease-in-out}.overlay-active[_ngcontent-%COMP%]{opacity:1}"];
export { styles as styles };
